
export default function ClearFloat() {
  return (
    <div style={{clear:"both"}}></div>
  )
}